import { Component, OnInit } from '@angular/core'
import buildDate from '../environments/buildDate.json'

@Component({
  selector: 'lib-sbs-common',
  template: ` <p>Deployed common on: {{ buildTimestamp }}</p>`,
  styles: [],
})
export class SbsCommonComponent implements OnInit {
  buildTimestamp: Date

  constructor() {
    this.buildTimestamp = new Date(buildDate.timestamp)
  }

  ngOnInit(): void {}
}
